export const TopCitiesNameList = [
  'London, United Kingdom',
  'Paris, France',
  'Berlin, Germany',
  'Barcelona, Spain',
  'Milan, Italy',
  'Rotterdam, Netherlands',
  'Vienna, Austria',
  'Madrid, Spain',
  'Brussels, Belgium',
];
